// 2026/4/13
// 3枚固定表示 + 4枚目以降スライド（dots対応）
// 担当：四方

(function () {
  'use strict';

  function initSlider(root) {
    const track = root.querySelector('.img-slider-3plus__track');
    const slides = Array.from(root.querySelectorAll('.img-slider-3plus__slide'));
    const prev = root.querySelector('.img-slider-3plus__prev');
    const next = root.querySelector('.img-slider-3plus__next');

    const visible = 3; //同時表示枚数
    let index = 0;
    const maxIndex = slides.length - visible;

    // update関数を設定
    function update() {

      // const=再代入不可の変数　横に何％ずらすか
      const offset = -(100 / visible) * index;

      // indexに応じて横にスライド
      track.style.transform = `translateX(${offset}%)`;

      // 左矢印（右端の場合、非表示）
      if (prev) {
        prev.style.display = index === 0 ? 'none' : '';
      }

      // 右矢印（左端の場合、非表示）
      if (next) {
        next.style.display = index >= maxIndex ? 'none' : '';
      }
    }
  
    // 左矢印の動作
    if (prev) {
      prev.addEventListener('click', () => {
        if (index > 0) {
          index--;
          update();
        }
      });
    }
    
    // 右矢印の動作
    if (next) {
      next.addEventListener('click', () => {
        if (index < maxIndex) {
          index++;
          update();
        }
      });
    }

    // Initial
    update();
    
  }

  function initAll() {
    document.querySelectorAll('.img-slider-3plus').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

})();